import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getDatabase, ref, set } from 'firebase/database';

export const sendPosition = createAction(
    'global/sendPosition',
    ({ x, y }: { x: number; y: number }) => {
        const db = getDatabase();

        set(ref(db, 'position'), {
            x,
            y,
        });

        return { payload: undefined };
    },
);

export const syncPosition = createAction<{ x: number; y: number }>('global/syncPosition');

export const listenPosition = createAction('global/listenPosition', () => {
    return { payload: undefined };
});

export const detachPositionListener = createAction('global/detachPositionListener', () => {
    return { payload: undefined };
});

export const actionB = createAction('global/actionB', (value: number) => {
    return {
        payload: value,
    };
});

export const actionC = createAsyncThunk(
    'global/actionC',
    /* eslint-disable @typescript-eslint/no-unused-vars */
    // @ts-ignore 6918
    async (value: number, { dispatch, getState }) => {
        return value;
    },
    /* eslint-enable @typescript-eslint/no-unused-vars */
);
